import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

function formatCompact(num) {
  if (!num || num === 0) return "R$ 0";
  const absNum = Math.abs(num);
  if (absNum >= 1000000) return `R$ ${(num / 1000000).toFixed(1)}M`;
  if (absNum >= 1000) return `R$ ${(num / 1000).toFixed(1)}K`;
  return `R$ ${num.toFixed(0)}`;
}

export default function MonthlyChart({ data }) {
  if (!data || data.length === 0) return null;

  const maxVal = Math.max(...data.flatMap((d) => [d.compras, d.vendas, d.impostos]));

  return (
    <div className="chart-container monthly-chart">
      <h4>Evolução Mensal</h4>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} opacity={0.1} />
          <XAxis
            dataKey="mes"
            tick={{ fontSize: 11, fill: "currentColor", opacity: 0.6 }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis hide />
          <Tooltip
            contentStyle={{
              background: "rgba(17, 24, 39, 0.95)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              borderRadius: "8px",
              padding: "12px",
              fontSize: "12px",
              color: "#fff",
            }}
            formatter={(value, name) => [formatCompact(value), name]}
          />
          <Bar dataKey="compras" fill="#3b82f6" radius={[4, 4, 0, 0]} />
          <Bar dataKey="vendas" fill="#10b981" radius={[4, 4, 0, 0]} />
          <Bar dataKey="impostos" fill="#ef4444" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
